import React, { useState } from 'react';
import { Box, Button, TextField, Card, CardContent, Typography, Grid, Dialog, DialogTitle, DialogContent, DialogActions } from '@mui/material';
import { AppLayout } from '../components/layout/AppLayout';
import { Loader } from '../components/common/Loader';
import { useChildrenSurveys } from '../hooks/useChildrenSurveys';

export const ChildrenPage: React.FC = () => {
  const [showAddDialog, setShowAddDialog] = useState(false);
  const [childName, setChildName] = useState('');
  const [childDob, setChildDob] = useState('');

  const { children, isLoadingChildren, childrenError, handleAddChild } = useChildrenSurveys();

  const handleAddNew = async () => {
    if (childName) {
      const result = await handleAddChild({
        name: childName,
        birthday: childDob || undefined,
      });
      if (result.success) {
        setShowAddDialog(false);
        setChildName('');
        setChildDob('');
      }
    }
  };

  if (isLoadingChildren && children.length === 0) {
    return <AppLayout title="Мои дети"><Loader message="Загрузка..." /></AppLayout>;
  }

  if (childrenError) {
    return (
      <AppLayout title="Мои дети">
        <Typography color="error">Ошибка: {childrenError}</Typography>
      </AppLayout>
    );
  }

  return (
    <AppLayout title="Мои дети">
      <Box sx={{ marginBottom: 3 }}>
        <Button variant="contained" onClick={() => setShowAddDialog(true)}>
          + Добавить ребёнка
        </Button>
      </Box>

      {children.length === 0 ? (
        <Typography color="textSecondary">Дети не добавлены</Typography>
      ) : (
        <Grid container spacing={2}>
          {children.filter(Boolean).map((child) => (
            <Grid item xs={12} sm={6} key={child.id}>
              <Card>
                <CardContent>
                  <Typography variant="h6">{child.name}</Typography>
                  {child.birthday && (
                    <Typography variant="body2" color="textSecondary">
                      Дата рождения: {new Date(child.birthday).toLocaleDateString('ru-RU')}
                    </Typography>
                  )}
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      )}

      <Dialog open={showAddDialog} onClose={() => setShowAddDialog(false)}>
        <DialogTitle>Добавить ребёнка</DialogTitle>
        <DialogContent>
          <TextField fullWidth label="Имя" value={childName} onChange={(e) => setChildName(e.target.value)} sx={{ marginTop: 2, marginBottom: 2 }} />
          <TextField fullWidth label="Дата рождения" type="date" value={childDob} onChange={(e) => setChildDob(e.target.value)} InputLabelProps={{ shrink: true }} />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setShowAddDialog(false)}>Отмена</Button>
          <Button variant="contained" onClick={handleAddNew} disabled={!childName}>Добавить</Button>
        </DialogActions>
      </Dialog>
    </AppLayout>
  );
};
